export type GanttMountMode = 'doc' | 'edgeless';

/**
 * Resolves which host flavour the Gantt UI is mounted under. Walks up
 * the DOM until it finds either `affine-edgeless-database`
 * (canvas mode) or `affine-database` (doc mode).
 *
 * The alternative — consuming a Lit context — would couple
 * `@blocksuite/data-view` to `@blocksuite/affine-blocks-database`,
 * which is the opposite direction of the package graph. Walking the
 * DOM keeps this file free of that dep.
 */
export function detectMountMode(el: HTMLElement): GanttMountMode {
  let current: Element | null = el;
  while (current && current !== document.body) {
    const tag = current.tagName?.toLowerCase();
    if (tag === 'affine-edgeless-database') return 'edgeless';
    if (tag === 'affine-database') return 'doc';
    current = current.parentElement;
  }
  return 'doc';
}
